<tt-divider>
    <tt-divider-rows>
        <tt-divider-pane>
            <tt-grid [(ttOptions)]="providersGrid" ttRowSelection="single" (ttOnRead)="onProvidersGridRead()" (ttOnRowSelected)="onProviderSelected($event)"></tt-grid>
        </tt-divider-pane>
        <tt-divider-pane>
            <tt-grid *ngIf="!!modelsGrid && page.ai_provider_keyno !== null" [(ttOptions)]="modelsGrid"></tt-grid>
            <tt-toast *ngIf="showProviderSelectionPrompt && page.ai_provider_keyno === null" ttType="primary" ttTitle="ai_settings_select_provider_to_see_models"></tt-toast>
        </tt-divider-pane>
    </tt-divider-rows>
</tt-divider>
